import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "submit", "text", "rating" ]

  connect() {
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    if (!this.hasSubmitTarget) return

    const hasRating = this.hasRatingTarget && parseInt(this.ratingTarget.value, 10) > 0
    const hasText = this.hasTextTarget && this.textTarget.value.trim().length > 0

    this.submitTarget.disabled = !(hasRating && hasText)
  }

  textChanged() {
    this.updateSubmitButton()
  }

  ratingChanged() {
    this.updateSubmitButton()
  }
}
